import { useEffect, useRef, useState } from 'react';
import { UseSynchronizedStateParams } from './useSynchronizedState.types';

const useSynchronizedState = <T,>(params: UseSynchronizedStateParams<T>) => {
  const { initialValue, syncRefWith } = params;

  const [state, setState] = useState<T>(initialValue);
  const ref = useRef<T>(syncRefWith ?? initialValue);

  useEffect(() => {
    ref.current = syncRefWith ?? state;
  }, [state, syncRefWith]);

  return [state, setState, ref] as const;
};

export default useSynchronizedState;
